import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ActivitySelectionBlockWidget } from "./ActivitySelectionBlock/ActivitySelectionBlock.widget";
/**
 * Renders a shared block. Returns the element if the block kind is handled,
 * or null if not recognized (so the caller can fall through to frontend-specific rendering).
 */ export const generateSharedBlock = (block)=>{
    if (block.kind === "activities_selection_block") {
        return /*#__PURE__*/ _jsx(ActivitySelectionBlockWidget, {
            ...block
        });
    } else {
        return null;
    }
};
/**
 * Converts a ParsedParagraph to a SharedBlock if it matches a shared bundle.
 * Returns undefined if the paragraph is not a shared block type.
 */ export const toSharedBlock = (p)=>{
    if (p.bundle === "activities_selection_block") {
        return {
            kind: "activities_selection_block",
            ...p
        };
    }
    return undefined;
};
